exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.small.avatar.image {\n  margin: auto; }\n\n.accordion.ui span, .accordion.ui i {\n  color: white; }\n\n.accordion.ui img {\n  max-width: 100%; }\n\n.accordion.ui .content {\n  transition: 0.3s all;\n  display: block !important;\n  visibility: hidden;\n  transform-origin: top;\n  transform: scaleY(0);\n  height: 0; }\n  .accordion.ui .content.active {\n    visibility: visible;\n    transform: scaleY(1);\n    height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainPrice/MainPrice.scss
// module id = 1258
// module chunks = 0